import UnauthorizedPage from '../pages/UnauthorizedPage/UnauthorizedPage';
import { person, alertCircle, people, cloudUploadOutline } from 'ionicons/icons';
import IRouteInfo from '../interfaces/IRouteInfo';
import RouteCategories from '../data/RouteCategories';
import UserRoles from '../data/UserRoles';
import { CreateRoutes } from '../services/RoutingHelperService';
import IUser from '../interfaces/IUser';
import FellowshipGroupPage from '../pages/FellowshipGroupPage/FellowshipGroupPage';
import FellowshipProfilePage from '../pages/FellowshipProfilePage/FellowshipProfilePage';
import FellowshipCreateGroupPage from '../pages/FellowshipCreateGroupPage/FellowshipCreateGroupPage';
import FellowshipJoinGroupPage from '../pages/FellowshipJoinGroupPage/FellowshipJoinGroupPage';
import FellowshipGroupProfilePage from '../pages/FellowshipGroupProfilePage/FellowshipGroupProfilePage';
import SyncUserData from '../pages/SyncUserData/SyncUserData';

export enum UserRouteKeys {
    Unauthorized,
    FellowshipProfile,
    FellowshipGroup,
    FellowshipGroupProfile,
    FellowshipGroupCreate,
    FellowshipGroupJoin,
    SyncUserData,
}

export const UserRouteInfo: {[ key in UserRouteKeys ]: IRouteInfo } = {
        [UserRouteKeys.Unauthorized]:
        {
            title: 'Unauthorized',
            path: '/unauthorized', 
            component: UnauthorizedPage,
            icon: alertCircle,
            category: RouteCategories.userAccount,
            roles: [ UserRoles.unregistered ],
            autoInstantiate: true,
        },
        [UserRouteKeys.FellowshipProfile]:
        {
            title: 'Profile',
            path: '/fellowship-profile',
            component: FellowshipProfilePage,
            icon: person,
            themeColorName: 'tertiary',
            category: RouteCategories.userAccount,
            roles: [ UserRoles.unregistered ],
            autoInstantiate: true,
        },
        [UserRouteKeys.FellowshipGroup]:
        {
            title: 'Group',
            path: '/fellowship-group/:nav?',
            component: FellowshipGroupPage,
            icon: people,
            themeColorName: 'tertiary',
            category: RouteCategories.userAccount,
            roles: [ UserRoles.unregistered ],
            autoInstantiate: true,
        },
        [UserRouteKeys.FellowshipGroupProfile]:
        {
            title: 'Profile',
            path: '/fellowship-group-profile',
            component: FellowshipGroupProfilePage,
            icon: people,
            themeColorName: 'tertiary',
            category: RouteCategories.userAccount,
            roles: [ UserRoles.unregistered ],
            autoInstantiate: true,
        },
        [UserRouteKeys.FellowshipGroupJoin]:
        {
            title: 'Group',
            path: '/fellowship-group-join/:loadJoinCode?',
            rootPath: '/fellowship-group-join/',
            component: FellowshipJoinGroupPage,
            icon: people,
            themeColorName: 'tertiary',
            category: RouteCategories.userAccount,
            roles: [ UserRoles.unregistered ],
            autoInstantiate: true,
        },
        [UserRouteKeys.FellowshipGroupCreate]:
        {
            title: 'Group',
            path: '/fellowship-group-create',
            component: FellowshipCreateGroupPage,
            icon: people,
            themeColorName: 'tertiary',
            category: RouteCategories.userAccount,
            roles: [ UserRoles.unregistered ],
            autoInstantiate: true,
        },
        [UserRouteKeys.SyncUserData]:
        {
            title: 'Backup/Sync',
            path: '/sync-user-data',
            component: SyncUserData,
            icon: cloudUploadOutline,
            themeColorName: 'medium',
            category: RouteCategories.userAccount,
            roles: [ UserRoles.unregistered ],
            autoInstantiate: true,
        }
};

export const UserRouteInfoArray = Array.from(Object.values(UserRouteInfo));

export const UserRoutes = (loggedIn:boolean, currentUser:IUser | undefined) => CreateRoutes(UserRouteInfoArray, 'UserRoutes', loggedIn, currentUser);

export default UserRoutes;